<template>
    <div class="userInfo content">
        <div>
            <Button type="primary" @click="add()">添加</Button>
        </div>
        <div class="userInfo_box">
            <Table :loading="loading" border ref="selection" :columns="columns" :data="userInfoList"></Table>
        </div>
    </div>
</template>
<style scoped>
    .userInfo_box {
        margin-top: 20px;
    }
</style>
<script>
    import Http from '../../../libs/http.js'
    export default {
        data() {
            return {
                userInfoList:[],
                loading:false,
                gardenId: this.$route.query.gardenId,
                name: this.$route.query.name,
                columns:[
                    {
                        title: 'No.',
                        type: 'index',
                    },
                    {
                        title:'老师姓名',
                        key:'name',
                        render:(h,params) => {
                            return h("span", params.row.name ? params.row.name : '无');
                        }
                    },
                    {
                        title:'老师账号',
                        key:'telnum',
                    },
                    {
                        title:'完善资料',
                        key:'type',
                        render:(h,params) => {
                            return h("span", params.row.type==1 ? '是' : '否');
                        }
                    },
                    {
                        title:'账号状态',
                        key:'status',
                        render:(h,params) => {
                            return h("span", this.changeStatus(params.row.status));
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small',
                                        disabled: params.row.status == 2 ? true :false,
                                    },
                                    on: {
                                        click: () => {
                                            this.blockUp(params.row)
                                        }
                                    }
                                }, params.row.status == 2 ? '已停用' :'停用'),
                            ]);
                        }
                    }
                ]
            }
        },
        created() {
            this.getList()
        },
        methods: {
            changeStatus(status) {
                switch(status + '') {
                    case '0':
                        return '初始'
                        break;
                    case '1':
                        return '正常'
                        break;
                    case '2':
                        return '停用'
                        break;
                }
            },
            //获取老师列表
            getList() {
                var _this = this
                Http.post('/custom/madyUser/opt',{
                    opt:1,
                    gardenId:_this.gardenId
                }).then(res=>{
                    if(res) {
                        _this.userInfoList = res
                    }
                })
            },
            //添加账号
            add() {
                var _this = this
                _this.$router.push({ path: 'addUserInfo', query: {gardenId:_this.gardenId,name:_this.name} })
            },
            //停用
            blockUp(row) {
                var _this = this
                _this.loading = true
                this.$Modal.confirm({
                    title: '提示',
                    content: '是否确定停用此账号?',
                    onOk: () => {
                        Http.post('/custom/madyUser/opt', {
                            opt:3,
                            userId:row.id,
                            status: 2
                        }).then((res) => {
                            if(res){
                                _this.getList()
                                _this.loading = false
                                _this.$Message.success('停用成功');
                            }
                        })
                    },
                    onCancel: () => {

                    }
                });
            }
        }
    }
</script>
